import React from 'react';
import { Box, Container, Grid, Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const NewsReaderLayout = ({ children, sidebar }) => {
    const hasSidebar = Boolean(sidebar);
    return (
        <Box 
            sx={{ bgcolor: '#fff', height: '100%', display: 'flex', flexDirection: 'column' }}
            data-ui="layout-news-reader"
        >
            {/* Header / Breadcrumbs Section */}
            <Box 
                sx={{ bgcolor: 'grey.50', py: { xs: 2, md: 3 }, borderBottom: '1px solid', borderColor: 'grey.200' }}
                data-ui="section-news-breadcrumbs"
            >
	                 <Container maxWidth="md">
	                    <Breadcrumbs aria-label="breadcrumb">
	                        <Link component={RouterLink} to="/" color="inherit" underline="hover">R5 Projetos</Link>
	                        <Link component={RouterLink} to="/news" color="inherit" underline="hover">Notícias</Link>
	                        <Typography color="text.primary">Leitura</Typography>
	                    </Breadcrumbs>
	                 </Container>
            </Box>

            {/* Narrower container for reading: increases side margins and keeps gallery aligned to text. */}
            <Container maxWidth="md" sx={{ flex: 1, minHeight: 0, py: { xs: 3, md: 4 } }}>
                <Grid container spacing={{ xs: 3, md: 5 }} sx={{ height: '100%', minHeight: 0 }}>
                    {/* Main Content Column */}
                    <Grid item xs={12} md={hasSidebar ? 8 : 12} data-ui="column-news-main" sx={{ minHeight: 0 }}>
                        {children}
                    </Grid>

                    {/* Sidebar Column */}
                    {hasSidebar && (
                        <Grid item xs={12} md={4} data-ui="column-news-sidebar" sx={{ minHeight: 0 }}>
                            {sidebar}
                        </Grid>
                    )}
                </Grid>
            </Container>
        </Box>
    );
};

export default NewsReaderLayout;
